/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.HelpWindow = function( txt, fxStyle) {
    var Dialog = expocadfx.Dialog;
    var data = expocadfx.fxData;
    var elemById = expocadfx.element.elementById;
    var body = document.getElementsByTagName( "body")[0];
    
    var dialog = null;
    var obj = {
        title: txt.HELP_TITLE,
        headerBackgroudColor: fxStyle.windowHeader.clrBg !== "" ? 
            fxStyle.windowHeader.clrBg : fxStyle.mainHeader.clrBg,
        headerTextColor: fxStyle.windowHeader.clrText !== "" ? 
            fxStyle.windowHeader.clrText : fxStyle.mainHeader.clrText,
        cancelLabel: txt.CLOSE,
        width: 300,
        height: 360,
        padding: 10,
        posX: data.viewportWidth - 300 - 28,
        posY: data.viewportHeight - 360 - 20,
        draggable: true
    };
    
    if( fxStyle.windowHeader.gradBg !== "") {
        obj.headerBackground = fxStyle.windowHeader.gradBg;
    }
    else {
        if( fxStyle.windowHeader.clrBg === "" && fxStyle.mainHeader.gradBg !== "") {
            obj.headerBackground = fxStyle.mainHeader.gradBg;
        }
    }
    //   window size change, orientation change ????
    
    function helpHeading( value) {
        var element = document.createElement( "h6");
        element.style.fontWeight = "500";
        element.style.fontSize = "20px";
        element.style.letterSpacing = "0.15px";
        element.style.margin = "10px 0 5px";
        element.textContent = value;
        return element;
    }
    
    function helpSegment( value) {
        var element = document.createElement( "p");
        element.style.fontSize = "14px";
        element.style.paddingBottom = '10px';
        element.textContent = value;
        return element;
    }
    
    
    dialog = new Dialog( obj, body, elemById("mask"));

    dialog.content.style.padding = "0px 10px 5px";

    dialog.content.appendChild( helpHeading( txt.HELP_ZOOM_H));
    dialog.content.appendChild( helpSegment( txt.HELP_ZOOM_T));

    dialog.content.appendChild( helpHeading( txt.HELP_PAN_H));
    dialog.content.appendChild( helpSegment( txt.HELP_PAN_T));

    dialog.content.appendChild( helpHeading( txt.HELP_EXHIBITOR_H));
    dialog.content.appendChild( helpSegment( txt.HELP_EXHIBITOR_T));

    dialog.content.appendChild( helpHeading( txt.HELP_SEARCH_H));
    dialog.content.appendChild( helpSegment( txt.HELP_SEARCH_T));

    dialog.content.appendChild( helpHeading( txt.HELP_FAVORITES_H));
    dialog.content.appendChild( helpSegment( txt.HELP_FAVORITES_T));
    
    return dialog;
};